import { useTranslation } from "react-i18next";
import { clientèles } from "../Utils/Listings";
import MultiSelector from "./MultiSelector";

const EditClientèle = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <MultiSelector {...props} valuesListing={clientèles} label={i18n.language === "fr" ? "Clientèle" : "Customer base"} />
    );
}

export default EditClientèle;